
import { useEffect } from "react";
import { Card, Col, Row } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../../../../reduxToolkit/hooks";
import { setBookMarkList, setBookmark } from "../../../../../reduxToolkit/reducers/bookmarkTabsSlice";
import { BookmarkItems } from "../../../../../types/Applications";
import { dynamicImage } from "../../../../../utils";
import { Href } from "../../../../../constants";
import { Link } from "react-router-dom";
import { Edit2, Link as Links, Share2, Tag, Trash2 } from "react-feather";
import { Image } from "../../../../../coreComponents/Image";
import SearchNotFoundClass from "../../../../../coreComponents/SearchNotFoundClass";

// This component renders a list of bookmarked items marked as favorite, also allows users to remove them from favorites tab.
const DataList = () => {
  const { bookmark, bookMarkList } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const updatedList = bookmark.filter((data) => data.fillStar === true);
    dispatch(setBookMarkList(updatedList));
  }, [bookmark, dispatch]);

  const removeFromFavorite = (item: BookmarkItems) => {
    const updatedBookMark = bookmark.map((data) => (data.id === item.id ? { ...data, fillStar: false } : data));
    dispatch(setBookmark(updatedBookMark));
  };

  return (
    <Row>
      {bookMarkList.length > 0 ? (
        bookMarkList.map((myBookData: BookmarkItems) => (
          <Col xxl="3" md="4" key={myBookData.id}>
            <Card className="bookmark-card">
              <div className="details-website">
                <Image className="img-fluid" src={dynamicImage(`${myBookData.image}`)} alt="Image" />
                <div className={`favourite-icon ${myBookData.fillStar ? "favourite" : ""}`}>
                  <Link to={Href}>
                    <i className="fa fa-star" onClick={() => removeFromFavorite(myBookData)}></i>
                  </Link>
                </div>
                <div className="desciption-data">
                  <div className="title-bookmark">
                    <h4>{myBookData.title}</h4>
                    <p>{myBookData.website_url}</p>
                    <div className="hover-block">
                      <ul>
                        <li><a href={Href}><Edit2 /></a></li>
                        <li><a href={Href}><Links /></a></li>
                        <li><a href={Href}><Share2 /></a></li>
                        <li><a href={Href}><Trash2 /></a></li>
                        <li className="text-end"><a href={Href}><Tag /></a></li>
                      </ul>
                    </div>
                    <div className="content-general">
                      <p>{myBookData.desc}</p>
                      <span>{myBookData.collection}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        ))
      ) : (
        <SearchNotFoundClass word="Bookmark"/>
      )}
    </Row>
  );
};

export default DataList;
